import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./AppLayout";

const Specifications = lazy(() => import("./Products/Specifications"));
const Category = lazy(() => import("./Products/Category"));
const Products = lazy(() => import("./Products"));
const Home = lazy(() => import("./Homepage"));
const Downloads = lazy(() => import("./Downloads"));
const KnowUs = lazy(() => import("./KnowUs"));
const Support = lazy(() => import("./Support"));
const Press = lazy(() => import("./Press"));
const ProcessData = lazy(() => import("./ProcessData"));

function App() {
  return (
    <BrowserRouter>
      <AppLayout>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route exact path="/convert" element={<ProcessData />} />
            <Route exact path="/downloads" element={<Downloads />} />
            <Route exact path="/about" element={<KnowUs />} />
            <Route exact path="/support" element={<Support />} />
            <Route exact path="/press" element={<Press />} />
            <Route
              exact
              path="/products/:category/:modalNo"
              element={<Specifications />}
            />
            <Route exact path="/products/:category" element={<Category />} />
            <Route exact path="/products" element={<Products />} />
            <Route exact path="/" element={<Home />} />
          </Routes>
        </Suspense>
      </AppLayout>
    </BrowserRouter>
  );
}

function Loading() {
  return <></>;
}

export default App;
